/*
 * @Author: chenxuelai 2251702447@qq.com
 * @Date: 2023-07-05 09:21:29
 * @LastEditors: chenxuelai 2251702447@qq.com
 * @LastEditTime: 2023-07-18 10:52:49
 * @FilePath: /vue_huaqiang/src/api/supplier.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { ISupplierModel } from "@/api/types";
import request from "@/utils/request";
import lms_download from "@/utils/download";

export const defaultSupplierData: ISupplierModel = {
  id: null,
  code: null,
  name: null,
  abbreviation: null,
  generalCode: null,
  generalAbbreviation: null,
  address: null,
  purchaser: null,
  accountant: null,
  marker: null,
  orderAuditor: null,
  payment: null,
  accountPeriod: null,
  depositPercent: null,
  longTermDeposit: null,
  supplierProducts: null
};

export const getSuppliers = (params: { [key: string]: string | number }) =>
  request({
    url: "/suppliers",
    method: "get",
    params
  });


export const createSupplier = (data: { [key: string]: string }) =>
  request({
    url: "/suppliers",
    method: "post",
    data
  });

export const updateSupplier = (id: string, data: any) =>
  request({
    url: `/suppliers/${id}`,
    method: "put",
    data
  });


export const deleteSupplier = (id: string) =>
  request({
    url: `/suppliers/${id}`,
    method: "delete"
  });


export const uploadSuppliers = (data: any) =>
  request({
    url: "/suppliers/excel",
    method: "post",
    data
  });

export const findByCode = (code: string) =>
    request({
        url: `/suppliers/${code}`,
        method: "get"
    })

export const querySupplierProduct = (id: string) =>
    request({
        url: `/suppliers/${id}/products`,
        method: "get"
    })
    // /suppliers/abbreviation
export const getAbbreviation = (params) =>
    request({
        url: `/suppliers/abbreviation`,
        method: "get",
        params
    })
    // /supplier-cards/excel
export const postSupplierCardsExcel = (data: any) =>
    request({
        url: `/supplier-cards/excel`,
        method: "post",
        data
    })
    // /supplier-cards
    // 供应商名片信息列表接口
export const getsupplierCardsList = (params) =>
    request({
        url: `/supplier-cards`,
        method: "get",
        params
    })

    // /supplier-cards/{id}
    // 名片信息编辑接口
export const editSupplierCards = (id: any,params: any) =>
    request({
        url: `/supplier-cards/${id}`,
        method: "put",
        params
    })
export const deleteSupplierCards = (id: string) =>
    request({
      url: `/supplier-cards/${id}`,
      method: "delete"
    });

export const findSuppliersByKeyword = (keyword: string) =>
    request({
        url: `/suppliers/all/by-abbr-or-code?keyword=${keyword}`,
        method: "get",
    });

export const downloadAllInfo = () =>
    lms_download({
        responseType: "blob",
        url: `/suppliers/all`,
        method: "get"
    });

/**
 *  查询供应商下某个品名的所有中文单位。
 * @constructor
 */
export const querySupplierProductChineseUnits = (supplierAbbr:string, hqProductName:string) =>
    request({
        url: `/suppliers/products/chinese-units`,
        method: "get",
        params: {
            supplierAbbr: supplierAbbr,
            hqProductName: hqProductName
        }
    });
/**
 * 根据关键字分页查询供应商信息。
 * 同时通过权限过滤（经理查询所有供应商，普通员工的采购员只能查看自己负责的供应商，普通员工的其他角色无法查看供应商）
 * @param params
 */
export const queryUserSuppliers = (params) =>
    request({
        url: `/suppliers/auth`,
        method: "get",
        params
    });
